<template>
  <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.SALES_MANAGER]"
  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
        >
          <router-link :to="{ name: 'SiteCreate' }">
            <button class="btn">Add New</button>
          </router-link>
        </div>
        <v-server-table
          ref="siteTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';

export default {
  name: 'Sites',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      siteTable: null,
      columns: [
        'siteCode',
        'siteName',
        'supervisor',
        'siteType',
        'status',
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'siteCode',
          'siteName',
          'supervisor',
          'regionName',
          'siteType',
          'status',
        ],
        headings: {
          siteCode: 'Location Code',
          siteName: 'Location Name',
          supervisor: 'Supervisor (G.A Head)',
          regionName: 'Geographic Area',
          siteType: 'Type',
          status: 'Status',
        },
        templates: {
          supervisor(row,query){
            if(query.supervisorFirstName && query.supervisorLastName){
              return `${query.supervisorFirstName} ${query.supervisorLastName}`;
            }
            if(query.supervisorFirstName){
              return `${query.supervisorFirstName}`;
            }
            if(query.supervisorLastName){
              return `${query.supervisorLastName}`;
            }
          },

          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          siteType(row, query) {
            return query.siteType[0].toUpperCase() + query.siteType.slice(1);
          },
        },

        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            params.supervisor = this.user._id
          }
          if(this.user.roleName == "Sales Manager"){
            params.salesManager = this.user._id
          }
          
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'dateAdded';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$siteDataRepository.list(params).catch(error => {
            console.error('Site.requestFunction-error:', error);
            this.$snotify.error('Get Location', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.siteTable) {
        return this.siteTable.count > this.siteTable.limit ||
          this.siteTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
      
    }),
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'SiteDetail',
        params: { _id: data.row._id },
        props: data.row,
      });
    },

    getTitle(str) {
      return str[0].toUpperCase() + str.slice(1);
    },

    onLoaded() {
      this.siteTable = this.$refs.siteTable;
    },
    // getSelected(event) {
    // 	this.selectedStatus = event.target.value;
    // 	Event.$emit('vue-tables.filter', 'alphabet');
    // 	//this.$refs.siteTable.setFilter({'status': event.target.value})
    // }
  },
};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
        color: white
}
</style>





// WEBPACK FOOTER //
// Sites.vue?0680f813